import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, Search } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="border-b">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <Link href="/" className="font-bold text-xl" data-testid="link-home">
            ReviewKit
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="text-center max-w-lg">
          <div className="mb-8">
            <div className="text-[120px] sm:text-[180px] font-bold leading-none text-muted-foreground/20">
              404
            </div>
          </div>

          <h1 className="text-3xl sm:text-4xl font-bold mb-4" data-testid="text-404-title">
            Page not found
          </h1>
          
          <p className="text-muted-foreground text-lg mb-8">
            Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or never existed in the first place.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link href="/">
              <Button size="lg" data-testid="button-go-home">
                <Home className="w-4 h-4 mr-2" />
                Go to Homepage
              </Button>
            </Link>
            <Button 
              variant="outline" 
              size="lg" 
              onClick={() => window.history.back()}
              data-testid="button-go-back"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
          </div>

          <div className="mt-12 pt-8 border-t">
            <p className="text-sm text-muted-foreground mb-4">
              Looking for something specific?
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link href="/features" className="text-sm text-muted-foreground hover:text-foreground" data-testid="link-features">
                Features
              </Link>
              <Link href="/pricing" className="text-sm text-muted-foreground hover:text-foreground" data-testid="link-pricing">
                Pricing
              </Link>
              <Link href="/docs" className="text-sm text-muted-foreground hover:text-foreground" data-testid="link-docs">
                Documentation
              </Link>
              <Link href="/blog" className="text-sm text-muted-foreground hover:text-foreground" data-testid="link-blog">
                Blog
              </Link>
            </div>
          </div>
        </div>
      </main>

      <footer className="border-t py-6">
        <div className="max-w-7xl mx-auto px-6 text-center text-sm text-muted-foreground">
          2024 ReviewKit. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
